import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import { Nullable } from '../../types/utils.type'

@Injectable({ providedIn: 'root' })
export class WidgetContextService {
  private widgetIdParamSubject = new BehaviorSubject<number | null>(null)

  setWidgetId(widgetId: Nullable<number>) {
    this.widgetIdParamSubject.next(widgetId)
  }

  getWidgetId(): Nullable<number> {
    return this.widgetIdParamSubject.getValue()
  }
}
